/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChipSelectorComponent} from './chip-selector.component';
import {ChipSelectorZoneDropdownComponent} from './option-components/chip-selector-zone-dropdown/chip-selector-zone-dropdown.component';
import {ChipSelectorZoneDropdownOptionComponent} from './option-components/chip-selector-zone-dropdown/chip-selector-zone-dropdown-option/chip-selector-zone-dropdown-option.component';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {TooltipModule} from '../tooltip/tooltip.module';
import {InputModule} from '../input/input.module';

@NgModule({
    declarations: [ChipSelectorComponent, ChipSelectorZoneDropdownComponent, ChipSelectorZoneDropdownOptionComponent],
    exports: [
        ChipSelectorComponent
    ],
    imports: [
        CommonModule,
        NgbDropdownModule,
        TooltipModule,
        InputModule
    ]
})
export class ChipSelectorModule {
}
